export default __webpack_public_path__ + "static/media/in-large-chair.409409c0.jpeg";